/*
 * Copyright (c) 2022 CalAmp Corp.  All Rights Reserved
 */
import React, {memo} from 'react';
import {makeStyles} from '@material-ui/core';
import {translate} from '@ion/core/src/locale/locale';
import Accordion from '@ion/dls/src/components/accordion/Accordion';
import {dlsColor, dlsLayout, dlsTypography} from '@ion/dls/src/theme/theme';
import {DLSTheme} from '@ion/dls/src/types/types';
import IonTagCardListContent from './IonTagCardListContent';
import {IonTagDetailsPanelProps} from './IonTagDetailsPanel';

const useStyles = makeStyles((theme: DLSTheme) => {
  const padding = dlsLayout('gutters', 'mobile');
  const borderStyle: string = `1px solid ${dlsColor('grey5')}`;
  return {
    content : {
      paddingLeft  : padding,
      paddingRight : padding + 10,
      paddingTop   : 0
    },
    deviceDetails : {
      ...dlsTypography('panelCards'),
      fontFamily    : 'Roboto',
      fontWeight    : '600',
      fontSize      : '14px',
      lineHeight    : '17px',
      textTransform : 'uppercase',
      color         : dlsColor('black'),
      minHeight     : 48
    },
    ionTagCardListContentWrapper : {
      padding      : '15px',
      borderBottom : borderStyle
    },
    detailsRoot : {
      display   : 'block',
      padding   : '0px',
      borderTop : 'none'
    },
    ionTagDetailAccordion : {
      padding : '0 15px'
    },
    accordionRoot : {
      borderTop : borderStyle
    }
  };
});

const IonTagDetailsAccordion = ({device}: IonTagDetailsPanelProps) => {
  const classes = useStyles();

  return (
    <div className={classes.accordionRoot}>
      <Accordion className={classes.ionTagDetailAccordion}
        header={
          <div className={classes.deviceDetails}>
            {translate('tracking:ionTagDetail.header')}
          </div>
        }
        details={
          <div className={classes.ionTagCardListContentWrapper}>
            <IonTagCardListContent device={device} />
          </div>
        }
        padding={'0'}
        defaultExpanded={true}
        isCondensedVariant />
    </div>
  );
};

export default memo(IonTagDetailsAccordion);
